module.exports = ".custom-file-label:after{height:2.85rem}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/logo-upload/logo-upload.component.scss
// module id = ./src/app/shared/logo-upload/logo-upload.component.scss
// module chunks = main